import { Helmet } from "react-helmet-async";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BusinessHero from "./components/BusinessHero";
import CompanyRegistration from "./components/CompanyRegistration";
import InvestmentPortals from "./components/InvestmentPortals";
import BusinessOpportunities from "./components/BusinessOpportunities";

export default function BusinessPage() {
  return (
    <main>
      <Helmet>
        <title>How to Invest in East Africa | Business Opportunities & Company Registration | AIP</title>
        <meta name="description" content="Explore how to invest in East Africa — Rwanda, Kenya, Uganda, Tanzania, Ethiopia, Burundi, and DRC. Find investment opportunities, register a company, and access official investment authority portals." />
        <meta name="keywords" content="how to invest in East Africa, investment opportunities Africa, register company Rwanda, register company Kenya, invest in Ethiopia, invest in DRC, invest in Burundi, investment authority East Africa, business opportunities Africa" />
        <link rel="canonical" href="https://africainvestmentportal.com/business" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="How to Invest in East Africa | Business Opportunities | AIP" />
        <meta property="og:description" content="Find investment opportunities and learn how to register a company in Rwanda, Kenya, Uganda, Tanzania, Ethiopia, Burundi, and DRC." />
        <meta property="og:url" content="https://africainvestmentportal.com/business" />
        <meta property="og:image" content="https://africainvestmentportal.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="How to Invest in East Africa | Business Opportunities | AIP" />
        <meta name="twitter:description" content="Find investment opportunities and learn how to register a company in Rwanda, Kenya, Uganda, Tanzania, Ethiopia, Burundi, and DRC." />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "How to Invest in East Africa | Business Opportunities",
          "url": "https://africainvestmentportal.com/business",
          "description": "Explore how to invest in East Africa — Rwanda, Kenya, Uganda, Tanzania, Ethiopia, Burundi, and DRC.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://africainvestmentportal.com" },
              { "@type": "ListItem", "position": 2, "name": "Business & Investment", "item": "https://africainvestmentportal.com/business" }
            ]
          },
          "mainEntity": {
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Can foreigners invest in East Africa?",
                "acceptedAnswer": { "@type": "Answer", "text": "Yes, foreigners can invest across East Africa. Countries like Rwanda offer 100% foreign ownership with no minimum capital requirement, and most East African nations have established investment authorities to facilitate foreign direct investment." }
              },
              {
                "@type": "Question",
                "name": "How do I register a company in East Africa?",
                "acceptedAnswer": { "@type": "Answer", "text": "Company registration varies by country. Rwanda offers registration in as little as 3 days through the Rwanda Development Board. Kenya, Uganda, Tanzania, Ethiopia, Burundi, and DRC each have their own investment authorities and registration processes. AIP guides investors through the entire process." }
              },
              {
                "@type": "Question",
                "name": "Which countries in East Africa are best for investment?",
                "acceptedAnswer": { "@type": "Answer", "text": "Rwanda is ranked #2 in Africa for ease of doing business. Kenya offers a large consumer market. Uganda has strong agricultural and energy sectors. Tanzania is rich in natural resources. Each country offers unique investment advantages depending on your sector." }
              },
              {
                "@type": "Question",
                "name": "What sectors are most profitable for investment in East Africa?",
                "acceptedAnswer": { "@type": "Answer", "text": "High-growth sectors include technology, agriculture, real estate, healthcare, renewable energy, logistics, manufacturing, and tourism across East Africa." }
              }
            ]
          }
        })}</script>
      </Helmet>
      <Navbar />
      <BusinessHero />
      <CompanyRegistration />
      <InvestmentPortals />
      <BusinessOpportunities />
      <Footer />
    </main>
  );
}
